import { Flex, Tooltip } from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import { TeamsSurveyResultsVisibility } from "@teams/types";
import React, { useMemo } from "react";

import { DropdownField, DropdownItem } from "../../../_shared/components/fields";
import { SettingLabel } from "./SettingLabel";

type Props = {
  field: FieldDescriptor<TeamsSurveyResultsVisibility>;
  realTime: boolean;
  afterClose: boolean;
  privateResults: boolean;
  compressed?: boolean;
  isMoble?: boolean;
  disabled?: boolean;
};
export const ResultsVisibilityField: React.FC<Props> = ({
  field,
  realTime,
  afterClose,
  privateResults,
  compressed,
  isMoble,
  disabled,
}) => {
  const [options, tooltip] = useMemo(() => {
    const items: Array<DropdownItem<TeamsSurveyResultsVisibility> & { key: string }> = [];
    if (realTime) {
      items.push({
        key: "realtime",
        label: "everyone in realtime",
        value: "real-time",
      });
    }

    if (afterClose) {
      items.push({
        key: "afterclose",
        label: "show once closed",
        value: "after-close",
      });
    }

    if (privateResults) {
      items.push({ key: "private", label: "hidden from audience", value: "private" });
    }

    const tooltip = (
      <>
        {realTime && (
          <>
            <b>Real Time:</b> Results are visible to audience as they come in.
            <br />
          </>
        )}
        {afterClose && (
          <>
            <b>After Close:</b> Results are available to audience after voting is closed.
            <br />
          </>
        )}
        {privateResults && (
          <>
            <b>Private:</b> Results are only available to the the question sender.
          </>
        )}
      </>
    );

    return [items, tooltip];
  }, [realTime, afterClose, privateResults]);

  return (
    <Flex vAlign="center" wrap>
      <Tooltip content={tooltip}>
        <SettingLabel icon="view-icon" content={compressed ? "Results" : "Results visibility"} />
      </Tooltip>
      <DropdownField<TeamsSurveyResultsVisibility>
        field={field}
        fluid
        className="polly-authoring__dropdown"
        items={options}
        isMobile={isMoble}
        disabled={disabled}
      />
    </Flex>
  );
};
